module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[19]506.c05491a.woff2";